import isEmpty from 'lodash/isEmpty';
import { getIsWixApp, getShowConsentBehaviour } from '../selectors/appRuntimeReader';
import { ShowConsentBehaviour } from '@wix/ambassador-devcenter-appsruntimereader-v1-app-runtime-data/types';
export const shouldShowConsent = (app, version, isOneStepInstall, consentPermissions, isAppAlreadyInstalled) => {
  const arePermissionsUnchanged = isAppAlreadyInstalled && isEmpty(consentPermissions);
  if (arePermissionsUnchanged || isOneStepInstall || version === 'dev') {
    return false;
  }
  const showConsentBehavior = getShowConsentBehaviour(app);
  if (showConsentBehavior === ShowConsentBehaviour.SHOW_CONSENT) {
    return true;
  }
  if (showConsentBehavior === ShowConsentBehaviour.SKIP_CONSENT) {
    return false;
  }
  const isWixApp = getIsWixApp(app);
  return !isWixApp;
};
//# sourceMappingURL=consent.js.map